import { size4, size8, size12, size14, size16, size30, size36, size48 } from '../theme/scale';
export const SIZES = {
  sm: {
    'font-size': size14,
    padding: `${size4} ${size8}`,
    height: size30
  },
  md: {
    'font-size': size14,
    padding: `${size8} ${size12}`,
    height: size36
  },
  lg: {
    'font-size': size16,
    padding: `${size12} ${size16}`,
    height: size48
  }
};
//# sourceMappingURL=config.js.map